<div class="ui-datepicker">
  @if (label()) {
    <label class="ui-datepicker__label" [attr.for]="id() || null">
      {{ label() | uiLabelTranslate }}
      @if (required()) {
        <span class="ui-datepicker__required">*</span>
      }
    </label>
  }

  <p-datepicker
    class="ui-datepicker__control"
    [inputId]="id() || undefined"
    [ngModel]="dateValue()"
    (ngModelChange)="onDateChange($event)"
    [placeholder]="placeholder() | uiLabelTranslate"
    [disabled]="disabled()"
    [showIcon]="showIcon()"
    [dateFormat]="dateFormat()"
    [showButtonBar]="true"
    appendTo="body"
    styleClass="ui-datepicker__prime"
  />

  @if (error()) {
    <p class="ui-datepicker__error">{{ error() | uiLabelTranslate }}</p>
  } @else if (hint()) {
    <p class="ui-datepicker__hint">{{ hint() | uiLabelTranslate }}</p>
  }
</div>
